import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TagCloud from '../TagCloud/TagCloud';

export default class LocationForm extends Component {
  state = {
    showErrors: false,
    errors: {
      name: null,
    },
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { showErrors } = this.state;

    if (showErrors) {
      this.validate(nextProps);
    }
  }

  onChange = event => {
    const { onChange } = this.props;
    const { name, value } = event.target;

    if (value.includes('*') || value.includes('/')) {
      return;
    }

    onChange(name, value);
  };

  onChangeTag = tags => {
    const { onChange } = this.props;

    onChange('tags', tags);
  };

  errorClass = error => (error ? 'error' : null);

  validate = nextProps => {
    const props = nextProps || this.props;
    const {
      location: { name },
    } = props;
    const errors = {};

    if (!name || !name.trim()) {
      errors.name = 'This field cannot be empty.';
    } else if (!this.isUniqueSiblingName(props)) {
      errors.name = 'This is already in use.';
    }

    this.setState({ showErrors: true, errors });

    return !errors.name;
  };

  submit = event => {
    const { onUpdate } = this.props;

    event.preventDefault();

    if (this.validate()) {
      onUpdate();
    }
  };

  isUniqueSiblingName = props => {
    const { locations, location } = props;
    const siblings = locations.filter(item => item.parent === location.parent);

    return !siblings.some(item => {
      const name = location.name.toLowerCase().trim();
      const itemName = item.name.toLowerCase().trim();

      return +item.id !== +location.id && itemName === name;
    });
  };

  render() {
    const {
      auth: {
        user: {
          permissions: { Writer },
        },
      },
      location,
      onCancel,
    } = this.props;
    const { errors } = this.state;

    if (!location) {
      return null;
    }

    const { name, description, tags } = location;

    return (
      <div
        id="edit"
        className="form-signs lg:col-span-8 mt-4 bg-white rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,0,0,0.05)] border border-gray-200 p-4"
      >
        <form className="space-y-6" onSubmit={this.submit}>
          <div className="grid grid-cols-2 gap-4">
            <div className="relative group">
              {this.errorClass(errors.name) && (
                <span className="text-sunrise font-bold mt-1 mb-1">{errors.name}</span>
              )}
              <label
                htmlFor="location-input-name"
                className="form-label text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 absolute -top-2 left-6 bg-white px-2 transition-all group-focus-within:text-warmth"
              >
                Location Name
              </label>
              <input
                id="location-input-name"
                data-test="input-name"
                type="text"
                name="name"
                value={name}
                onChange={this.onChange}
                disabled={!Writer}
                className="w-full text-xl font-bold px-2 py-3 rounded-2xl border border-gray-200 focus:border-warmth focus:ring-0 transition-all outline-none"
              />
            </div>

            <div className="relative group">
              <label
                htmlFor="location-description"
                className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 absolute -top-2 left-6 bg-white px-2 transition-all group-focus-within:text-warmth"
              >
                Description
              </label>
              <textarea
                id="location-description"
                data-test="input-desc"
                rows="1"
                placeholder="Enter description"
                value={description}
                onInput={e => {
                  e.target.style.height = 'auto';
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
                onChange={this.onChange}
                disabled={!Writer}
                name="description"
                className="w-full text-xl font-medium px-2 py-3 rounded-2xl border border-gray-200 focus:border-warmth focus:ring-0 transition-all outline-none resize-none"
              />
            </div>

            <TagCloud tags={tags} onChange={this.onChangeTag} disabled={!Writer} />
          </div>

          <div className="px-4 py-3 rounded-2xl bg-yellow-50 border border-yellow-200 text-yellow-800 text-sm font-medium">
            Renaming this Location will trigger a restart of the Devices within.
          </div>

          <div className="pt-6 flex flex-col sm:flex-row gap-4">
            {Writer && (
              <button
                key="2"
                type="submit"
                data-test="button-update"
                className="flex-1 bg-btn-primary-form text-white px-8 py-4 rounded-2xl font-bold uppercase tracking-widest text-xs hover:scale-[1.02] active:scale-[0.98] transition-all shadow-lg shadow-black/20"
              >
                Update Location
              </button>
            )}
            <button
              key="3"
              type="button"
              data-test="button-cancel"
              className="px-8 py-4 rounded-2xl font-bold uppercase tracking-widest text-xs text-gray-400 hover:text-black transition-colors border border-transparent hover:border-gray-200"
              onClick={onCancel}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    );
  }
}

LocationForm.propTypes = {
  auth: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  locations: PropTypes.array,
  location: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
